import React from 'react';
interface SectionHeadingProps {
  index: string;
  title: string;
  description?: string;
}
export function SectionHeading({
  index,
  title,
  description
}: SectionHeadingProps) {
  return <div className="max-w-2xl" data-id="element-235" data-mp="3f1c3by8onkzw">
      <p className="font-mono text-xs text-teal" data-id="element-236" data-mp="3f2dqv26vxzyi">{index}</p>
      <h2 className="mt-3 font-mono text-3xl font-bold tracking-tight text-ink-hi sm:text-4xl" data-id="element-237" data-mp="3jzx3jxnxq4oc">
        {title}
      </h2>
      {description ? <p className="mt-4 leading-relaxed text-ink-mid" data-id="element-238" data-mp="blohz9jtye5o">{description}</p> : null}
    </div>;
}